module.exports = __webpack_public_path__ + "static/media/iphone.2e0ff4a3.svg";